// extracted by mini-css-extract-plugin
export default {"container":"sWKw-___VideoPlayer-module__container","story":"Bgb5s___VideoPlayer-module__story"};